import { render } from "./ChatRow.vue?vue&type=template&id=6cc5d5a0&scoped=true"
import script from "./ChatRow.vue?vue&type=script&lang=js"
export * from "./ChatRow.vue?vue&type=script&lang=js"

import "./ChatRow.vue?vue&type=style&index=0&id=6cc5d5a0&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc5d5a0"]])

export default __exports__